import initReviewLink from './init_review_link';

function productReviews($container) {
    initReviewLink($container);
}

export default productReviews;